import Backbone from 'backbone'
import HeaderView from './header'
import NavView from './nav'

const FormView = Backbone.View.extend({
    el: '#current-view',
    tagName: 'div',
    id: 'form-view',
    inputSettings: 'autocomplete=off autocorrect=off autocapitalize=off spellcheck=false',
    render() {
        let model = this.model || new Backbone.Model()
        model = model.toJSON()
        model.input_settings = this.inputSettings

        this.$el.html(this.template(model))

        const headerView = new HeaderView()
        this.$('#header-view').append(headerView.render().el)

        const navView = new NavView()
        this.$('#nav-view').append(navView.render().el)
        return this
    }
})

export default FormView